import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import { ApiUrl } from '../util/api.url';
import { BaseService } from './base.service';
export var EnqueteService = /*#__PURE__*/function () {
  function EnqueteService() {
    _classCallCheck(this, EnqueteService);
  }
  _createClass(EnqueteService, null, [{
    key: "SignUp",
    value: function () {
      var _SignUp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(request) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return BaseService.postApiCall(this.baseUrl + 'Signup', request);
            case 2:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function SignUp(_x) {
        return _SignUp.apply(this, arguments);
      }
      return SignUp;
    }()
  }, {
    key: "GetSurveyInformation",
    value: function () {
      var _GetSurveyInformation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return BaseService.postApiCall(this.baseUrl + 'GetSurveyInformation', token);
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function GetSurveyInformation(_x2) {
        return _GetSurveyInformation.apply(this, arguments);
      }
      return GetSurveyInformation;
    }()
  }, {
    key: "GetTyperingen",
    value: function () {
      var _GetTyperingen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return BaseService.getApiCall(this.baseUrl + 'GetTyperingen');
            case 2:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function GetTyperingen() {
        return _GetTyperingen.apply(this, arguments);
      }
      return GetTyperingen;
    }()
  }, {
    key: "UpdateSoTypering",
    value: function () {
      var _UpdateSoTypering = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(request) {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return BaseService.postApiCall(this.baseUrl + 'UpdateSoTypering', request);
            case 2:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function UpdateSoTypering(_x3) {
        return _UpdateSoTypering.apply(this, arguments);
      }
      return UpdateSoTypering;
    }()
  }]);
  return EnqueteService;
}();
EnqueteService.baseUrl = ApiUrl.webapiurl() + '/Enquete/';